module.exports = __webpack_public_path__ + "img/lupa_branca.83d42473.svg";